/**
 * The sign-in thumbs-up. The login page is gone the moment the portal opens,
 * so the owl gives its thumbs-up on the sidebar's gem (`SignInGem`), the first
 * logo the portal shows, never holding anything back. Set by the login page
 * just before the sign-in call, taken once by the sidebar; it expires, so a
 * sign-in that lands outside the shell (the full-screen booking page) never
 * plays it later out of context.
 *
 * Plan: docs/plans/2026-10-22-owl-waits-everywhere.md (sign-in)
 */
const FRESH_MS = 10_000;
let signedInAt: number | null = null;

export function markSignedIn(): void {
  signedInAt = Date.now();
}

/** True once, within 10 s of a sign-in on this page; then false. */
export function takeSignedIn(): boolean {
  const fresh = signedInAt !== null && Date.now() - signedInAt < FRESH_MS;
  signedInAt = null;
  return fresh;
}
